import { Column } from "./Column";
import { Row } from "./Row";
export * from "./Row";
export * from "./Column";
export const Layout = {
  Row,
  Column,
};
